(function () {
  // Mobile menu
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    if (open) { nav.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    if (close) { nav.removeAttribute('open'); document.body.style.overflow = ''; }
  });

  // Search toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = document.querySelector('[data-search-bar]');
    if (!bar) return;
    bar.classList.toggle('is-open');
    var input = bar.querySelector('input');
    if (bar.classList.contains('is-open') && input) input.focus();
  });

  // Variant picker: map option selections to a variant id
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-product-price]');
    var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    function update() {
      var selected = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-sold-out');
      }
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = '<div class="price">' + html + '</div>';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
